<div style="padding-top: 8%; display: flex; justify-content: center; align-items: center" *ngIf="!noRecord">
  <mat-card class="iso-bubble" style="text-align: center; padding: 5px" xmlns="http://www.w3.org/1999/html">
    <div style="text-align: -webkit-center; text-align: -moz-center;height: 15px">
    </div>
    <div style="text-align: -webkit-center; position: inherit; top: -15px">
      <table style="width: 100%; text-align: center;">
        <tr>
          <td >
            <div class="lowerCaseLetters" style="font-weight: 800; font-size: 15px">Maher Terminals - {{areaOut}}</div>
          </td>
        </tr>
        <tr>
          <td>
            <ngx-barcode6 [bc-value]="visitNumber" [bc-format]="bcFormat" [bc-height]="bcHeight" id="barcode" ></ngx-barcode6>
          </td>
        </tr>
        <tr>
          <td>
            <div class="lowerCaseLetters" >Visit #:  {{visitNumber}}</div>
          </td>

        </tr>
        <ng-container *ngFor="let items of gateTrans">
        <tr>
          <td >
            <div class="lowerCaseLetters" *ngIf="items.showLines">SEQ:  {{items.transaction_number}}  <a style="padding-left: 15px" *ngIf="items.group_code==null">{{items.transaction_type}}:{{items.container}}</a> <a style="padding-left: 15px" *ngIf="items.transaction_type=='DI' && items.group_code!=null">GRP:{{items.group_code}}</a></div>
          </td>
        </tr>
        <tr>
          <td >
            <div class="lowerCaseLetters" *ngIf="items.showLines">SSL:  {{items.line_id_description}} <a style="padding-left: 15px">ISO: {{items.container_iso_code}} </a>   <a style="padding-left: 15px" *ngIf="items.transaction_type=='RE' || items.transaction_type=='DM'">BK:  {{items.booking}}</a></div>
          </td>
        </tr>
        </ng-container>




        <tr style="height: 4px"></tr>
        <tr>
          <td >
            <div class="lowerCaseLetters" >SL: {{driver_card_id}}  <a style="padding-left: 15px">TRK: {{truckingCo}} </a></div>
          </td>
        </tr>
        <tr>


        <tr>
          <td  *ngIf="portExclusions!=null && portExclusions.length>0">
            <div class="inboundInspection inboundInspectionAddOn" >
              <div class="inboundInspectionContentbehind inboundInspectionContentBehindAddOn">
                Port Exclusions
                <div class="lowerCaseLetters" style="padding-bottom: 2px; color: white; text-shadow: none" >Containers With The Following Prefixes Cannot Be Used For {{portSSLs}} </div>
              </div>
            </div>
            <span *ngFor="let items of portExclusions">
            <div class="inboundInspectionContentbehind peContentBehindAddOn" style="padding-top: 0px">
              <div class="lowerCaseLetters" style="text-align: -webkit-center; color: white; text-shadow: none">{{items.port_exclusions_prefixes}}</div>
            </div>
            </span>

          </td>
          <td>
        </tr>



        <tr>
          <td >
            <mat-card class="iso-bubble2" style="padding-bottom: 10px; padding-top: 10px; padding-left: 0px; padding-right: 0px">
              <div class="lowerCaseLetters" style="color: black; text-shadow: none; font-family: Oswald; font-size: 15px">{{firstLinePreText}} <a style="font-size: 20px; font-family: Oswald; color: green; font-family: Oswald">{{gotoMessage}}</a></div>
              <div class="lowerCaseLetters" style="color: black; text-shadow: none; font-family: Oswald; font-size: 15px" >{{secondLine}}</div>
              <div class="lowerCaseLetters" style="color: black; text-shadow: none; font-family: Oswald; font-size: 15px"  *ngIf="secondLineNAHalf!=''" [innerHTML]="secondLineNAHalf" ></div>
              <div class="lowerCaseLetters" style="color: black; text-shadow: none; font-family: Oswald; font-size: 15px" *ngIf="secondLineNAHalf2!=''" [innerHTML]="secondLineNAHalf2"></div>
              <div class="lowerCaseLetters" style="color: black; text-shadow: none; font-family: Oswald; font-size: 15px" *ngIf="secondLineNAHalf3!=''" [innerHTML]="secondLineNAHalf3"></div>
              <div *ngIf="!isRFIDError && !badSlotError && truckVisitStatus!='COMPLETE' && truckVisitStatus!='CLOSED' ">
                <span *ngFor="let items of gateErrors">
                              <div class="lowerCaseLetters" style="color: black; text-shadow: none; font-family: Oswald; font-size: 15px" >{{items.error_description}}</div>
                </span>
              </div>
              <div class="lowerCaseLetters" *ngIf="thirdLine!=''" style="color: black; text-shadow: none; font-family: Oswald; font-size: 15px" [innerHTML]="thirdLine"></div>
              <div class="lowerCaseLetters"  *ngIf="fourthLine!=''"  style="color: black; font-size: 15px; font-family: Oswald;text-shadow: none">{{fourthLinePreText}}<a [className]="fourthLine=='PENDING' || fourthLine=='VOIDED' || fourthLine=='DO NOT DRIVE BEHIND EMPTY EQUIPMENT' ? 'fourthRed' : 'fourthGreen'  ">{{fourthLine}}</a></div>
            </mat-card>
          </td>
        </tr>



        <tr style="height: 5px">
          <td *ngIf="!canceledRec">
            <mat-card class="iso-bubble2" style="padding: 0">

              <table style="width: 100%;border-collapse: collapse; border-spacing: 0" attribute rules=none>
                <tr style="background-color: rgba(26,47,75,1);">
                  <td style="text-align: right; background-color: rgba(26,47,75,1); border-top-left-radius: 5px; padding: 7px">
                    <div class="lowerCaseLetters" style="color: black; text-shadow: none; font-family: almoni; font-size: 16px; ; color: white; text-shadow: black 2px 2px 2px;     -webkit-font-smoothing: antialiased;">Gate Stages</div>
                  </td>
                  <td style="width: 4%; background-color: rgba(26,47,75,1)"></td>
                  <td style="text-align: -webkit-left;background-color: rgba(26,47,75,1);padding: 7px">
                    <div class="lowerCaseLetters" style="color: black; text-shadow: none; font-family: almoni; font-size: 16px; color: white;text-shadow: black 2px 2px 2px;     -webkit-font-smoothing: antialiased;">Status</div>
                  </td>
                  <td style="width: 12%; text-align: -webkit-left;background-color: rgba(26,47,75,1); border-top-right-radius: 5px;"></td>
                </tr>


                <tr *ngFor="let items of stagesForDisplay">
                  <td style="text-align: right; padding-right: 5px">
                    <div class="lowerCaseLetters" style="color: black; text-shadow: none;  font-family: Oswald; font-size: 15px">{{items.stage_desc}}</div>
                  </td>
                  <td style="width: 2%;"></td>
                  <td style="text-align: left; ">
                    <div [className]="items.stage_status=='COMPLETE' ? 'lowerCaseLettersGreen' : 'lowerCaseLettersRed'">{{items.stage_status}}</div>
                  </td>
                  <td style="width: 12%"></td>
                </tr>
              </table>
            </mat-card>
          </td>
        </tr>



        <tr>
          <td >
            <table style="width: 100%;  border-collapse: collapse; border-spacing: 0" attribute rules=none>
                <tr>
                  <td *ngIf="receiveCount>0 " style="width: 50%">
                    <div class="inboundInspection inboundInspectionAddOn"  (touchstart)="switchToInOut('R')"  (click)="switchToInOut('R')">
                      <div [className]="inboundOutboundDamages=='R' ? 'inboundInspectionContentbehind inboundInspectionContentBehindAddOn': 'inboundInspectionContentbehindGrey inboundInspectionContentBehindAddOn'  ">
                        Inbound Damages
                      </div>
                    </div>
                  </td>
                  <td *ngIf="deliverCount>0" style="width: 50%">
                    <div class="outboundInspection outboundInspectionAddOn" (touchstart)="switchToInOut('D')"  (click)="switchToInOut('D')">
                      <div [className]="inboundOutboundDamages=='D' ? 'outboundInspectionContentbehind outboundInspectionContentBehindAddOn': 'outboundInspectionContentbehindGrey outboundInspectionContentBehindAddOn'  ">
                          Outbound Damages
                      </div>
                    </div>
                  </td>
                </tr>
              </table>


            <div *ngIf="damageArray!=null && damageArray.length>0" style="border-bottom: #E61E00 1px solid">
              <ng-container *ngFor="let conts of containers">
              <ng-container *ngIf="conts.inOrOut==inboundOutboundDamages">
                <table style="width: 100%;  border-collapse: collapse; border-spacing: 0" attribute rules=none>
                    <tr>
                      <ng-container *ngIf="inboundOutboundDamages=='R'">
                        <td style="width:50%; min-width:50%;padding: 5px; font-size: 14px;  background-color: rgba(26,47,75,1); color: white; text-align: -webkit-right; font-size: 13px">
                          {{conts.container}}
                        </td>
                        <td style="text-align: -webkit-left"></td>
                      </ng-container>
                      <ng-container *ngIf="inboundOutboundDamages=='D'">
                        <td style="text-align: -webkit-left"></td>
                        <td style="width:50%; min-width:50%;padding: 5px; font-size: 14px;  background-color: rgba(26,47,75,1); color: white; text-align: -webkit-left; font-size: 13px">
                          {{conts.container}}
                        </td>
                      </ng-container>
                    </tr>
                </table>
              </ng-container>
              <table style="width: 100%; text-align: right">
                <ng-container *ngFor="let items of damageArray">
                <ng-container *ngIf="items.container==conts.container">
                <tr>
                  <ng-container *ngIf="inboundOutboundDamages=='R'">
                    <td style="width: 1%"></td>
                    <td  style="text-align: -webkit-left">
                      <div class="lowerCaseLetters" style="font-size: 13px">{{items.damage_component}} {{items.damage_type}}  {{items.damage_severity_calc}}</div>
                    </td>
                  </ng-container>
                  <ng-container *ngIf="inboundOutboundDamages=='D'" >
                    <td style="text-align: -webkit-right">
                      <div class="lowerCaseLetters" style="font-size: 13px">{{items.damage_component}} {{items.damage_type}}  {{items.damage_severity_calc}}</div>
                    </td>
                    <td style="width: 1%"></td>

                  </ng-container>

                </tr>
                </ng-container>
                </ng-container>
              </table>
              </ng-container>

            </div>


            <div *ngIf="damageArray!=null && damageArray.length==0 && (receiveCount>0 || deliverCount>0)" style="padding: 10px; border-bottom: #E61E00 1px solid">
                <div class="lowerCaseLetters" >No Damages For Container</div>
            </div>
          </td>
        </tr>

        <tr style="height: 6px"></tr>

















        <tr>
          <td >
            <div class="lowerCaseLetters" style="font-size: 10px; padding-top: 10px">N.J.A.C. 7-27014.3(a) PROHIBITS DIESEL POWERED MOTOR VEHICLES FROM IDLING FOR MORE THAN THREE MINUTES.</div>
            <div class="lowerCaseLetters" style="padding-top: 5px; font-size: 11px; font-weight: 800" >DRIVERS MUST WEAR A SAFETY VEST AT ALL TIMES WHEN ON TERMINAL</div>
          </td>
        </tr>


      </table>
    </div>
  </mat-card>
</div>


<div style="padding-top: 8%" *ngIf="noRecord">
    <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
      <div class="maher3" style="height: 11.5vh; width: 19vh;"></div>
    </div>

    <div style="text-align: -webkit-center; position: inherit; padding-top: 14%">
      <table style="width: 100%; text-align: center" >
        <tr>
          <td >
            <div class="lowerCaseLetters"  style="font-size: 44px; font-family: Oswald; color: black; text-shadow: none">No Active Visits</div>
          </td>
        </tr>
      </table>
    </div>
</div>
